import React, { useState,useEffect } from 'react'
import Item
 from './Item'
function Bag({bag,itemList,deletingItem,deleteBag,textEmpty,texte,handlingSettingItem,changedColor,changeQt}) {
   const [isDropdownOpened, setIsDropdownOpened] = useState(false);
   const [color,setColor] = useState(bag.Color);
   const [addedItem, setAddedItem] = useState({
    ID:0,
    Name: '',
    Quantity: 1
  });

  useEffect(() => { 
    changedColor(color,bag)
  },[color]);


   function openDropdown(){
    setIsDropdownOpened((prevstate)=> !prevstate);
    }

    function handleSubmit(e){
        if(addedItem.Name && addedItem.Quantity){
          e.preventDefault();
          handlingSettingItem(addedItem, bag.Name);
          setAddedItem({
            ID:0,
            Name: '',
            Quantity: 1
          });
        }
      }

  return (
<div className="bag" style={{'backgroundColor':color}}>
    <div style={{'width': '100%', 'textAlign': 'start', 'display':'flex', 'justifyContent':'space-between'}} onClick={() => openDropdown()}>
        <h2>{bag.Name}</h2>
       {!isDropdownOpened ?
        <h2 style={{'cursor':'pointer'}}>🔽</h2> :
        <h2 style={{'cursor':'pointer'}}>🔼</h2>} 
    </div> 
    
    {isDropdownOpened && 
        <div  style={{'width': '100%'}}>

            
      <div className="adding">
        <form onSubmit={($event)=> handleSubmit($event)}>
          <input
          className='input-object'
          placeholder={texte?.labelItem}
          value={addedItem.Name}
          onChange={(e)=> setAddedItem({...addedItem,Name:e.target.value})}
          maxlength="100"
          />

        <label>{texte?.quantite} 🔢:</label>
        <input type="number" name="quantity" min="1" max="100" value={addedItem.Quantity} onChange={(e)=> setAddedItem({...addedItem,Quantity:e.target.value})}></input>


          <button type="submit" className="button-input adding-btn" disabled={addedItem.Name ? false : true}>{texte?.ajoutItem}</button>
        </form>
      </div>



            {
                
                itemList.find(item => item.Bag === bag.Name)? (
                itemList.map((item) =>{
                    if(item.Bag === bag.Name){
                        return <Item key={item.ID} item={item} deleteItem={deletingItem} changeQt={changeQt}/>
                    }
                })
                ) : (
                    <h3 style={{'alignSelf': 'center'}}>{textEmpty}</h3>   
                )
            }
            <div style={{'display': 'flex','margin': '0em 2em 0em 0.5em','height': '3em','justifyContent': 'space-between'}}>
             <button style={{'cursor':'pointer'}} className='suppBag' onClick={()=> deleteBag(bag.ID)}>❌</button>
             <input  style={{'cursor':'pointer'}} className="color-input" onChange={(e)=> setColor(e.target.value)} type="color" value={color} />
            </div> 
        </div> 
      }
    </div>  
  )
}

export default Bag